export default __webpack_public_path__ + "unreal-engine-3.a43e137a.png";